import Chart from "chart.js/auto";

export default class ChartBlock {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".chart");
		this.piChart = this.el.querySelector(".pie-chart");
		this.dataElems = this.el.querySelectorAll(".chart__data");
		this.labels = [];
		this.backgrounds = [];
		this.percentages = [];
		this.themes = {
			themeBlue: "#00646e",
			themeBlueLight: "#bed6db",
			themeBlueDark: "#004250",
			themeGrayLight: "#e7ebed",
			themeYellow: "#ffe673",
			themeWhite: "#ffffff",
			themeOrange: "#ffc87d",
			themePink: "#ffa0d2",
			themeRed: "#ffa591",
			themeTurquoise: "#0096a0",
			themeTurquoiseLight: "#a5dccd",
		};
		this.init();
	}
	init() {
		this.fetchData();
	}
	fetchData() {
		const self = this;
		const keys = Object.keys(self.themes);

		this.dataElems.forEach((el, index) => {
			self.labels.push(
				el.dataset.label + "  " + parseInt(el.dataset.percentage) + "%"
			);
			self.percentages.push(parseInt(el.dataset.percentage));

			keys.forEach((key) => {
				if (key == el.dataset.background) {
					self.backgrounds.push(self.themes[key]);
				}
			});
		});
		setTimeout(() => {
			self.setChart();
		}, 50);
	}

	setChart() {
		const self = this;
		let screenWidth = screen.width;
		let isLargeScreen = screenWidth >= 1025;

		let options = {
			responsive: true,
			plugins: {
				legend: {
					display: false,
				},
				tooltip: {
					bodyFont: {
						size: 14,
						family: "'Mont'",
					},
					padding: 10,
					displayColors: false,
					callbacks: {
						label: function (context) {
							return context.label;
						},
					},
				},
			},
			layout: {
				padding: isLargeScreen ? 30 : 20,
			},
		};

		new Chart(this.piChart, {
			type: "pie",
			data: {
				labels: self.labels,
				datasets: [
					{
						backgroundColor: self.backgrounds,
						data: self.percentages,
						hoverOffset: 30,
					},
				],
			},
			options: options,
		});
	}
}
